__webpack_require__.p = "/adminportal/";